import frame1 from "../images/frames/frame-1.png";
import frame2 from "../images/frames/frame-2.png";
import frame3 from "../images/frames/frame-3.png";
import frame4 from "../images/frames/frame-4.png";
import frame5 from "../images/frames/frame-5.png";
import frame6 from "../images/frames/frame-6.png";
import frame7 from "../images/frames/frame-7.png";
import frame8 from "../images/frames/frame-8.png";
import frame9 from "../images/frames/frame-9.png";
import frame10 from "../images/frames/frame-10.png";
import frame11 from "../images/frames/frame-11.png";
import frame12 from "../images/frames/frame-12.png";

export const frameTypeList = [
    { id: 1, link: frame1 },
    { id: 2, link: frame2 },
    { id: 3, link: frame3 },
    { id: 4, link: frame4 },
    { id: 5, link: frame5 },
    { id: 6, link: frame6 },
    { id: 7, link: frame7 },
    { id: 8, link: frame8 },
    { id: 9, link: frame9 },
    { id: 10, link: frame10 },
    { id: 11, link: frame11 },
    { id: 12, link: frame12 },
];
